import React, { memo } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import EllipsisTextWithTooltip from '../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import styles from './index.module.scss';

const Item = ({
  title,
  note,
  description,
  info,
  iconComponent,
  action,
  isActive = false,
  isError = false,
  as = 'li',
  onClick,
  disabled = false,
  children,
  ...props
}) => {
  const Container = as;

  return (
    <Container {...props} className={styles.root}>
      <div className={cn(styles.cover, { [styles.disabled]: disabled })} />
      <div
        className={cn(styles.card, {
          [styles.active]: !isError && isActive,
          [styles.error]: isError,
          [styles.interactive]: typeof onClick === 'function',
        })}
        onClick={onClick}
      >
        {renderIcon(iconComponent)}

        <div className={styles.content}>
          {renderTitle({ title, note })}
          {Boolean(description || info) && (
            <div className={styles.descInfoContainer}>
              {renderDesc(description)}
              {renderInfo(info)}
            </div>
          )}
        </div>

        {renderAction(action)}
      </div>

      {children}
    </Container>
  );
};

Item.Memoized = memo(Item);

export default Item;

function renderIcon(component) {
  return component ? (
    <div className={styles.iconWrap}>
      <Icon component={component} className={styles.icon} />
    </div>
  ) : null;
}

function renderTitle({ title, note }) {
  return (
    <EllipsisTextWithTooltip
      as="h4"
      className={styles.title}
      tooltipTitle={[title, note].filter(Boolean).join(' ')}
    >
      {title}
      {Boolean(note?.trim()) && <span className={styles.note}> {note}</span>}
    </EllipsisTextWithTooltip>
  );
}

function renderDesc(desc) {
  return desc ? (
    <div style={{ minWidth: 0 }}>
      <EllipsisTextWithTooltip
        as="p"
        className={styles.desc}
        tooltipTitle={desc}
      >
        {desc}
      </EllipsisTextWithTooltip>
    </div>
  ) : null;
}

function renderInfo(info) {
  return info ? <div className={styles.info}>{info}</div> : null;
}

function renderAction(action) {
  return action ? <div style={{ marginLeft: 'auto' }}>{action}</div> : null;
}
